import React, { useContext, useState } from 'react';
import { useForm } from "react-hook-form";
import { toast } from 'react-hot-toast';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../../context/AuthProvider';
import useToken from '../../hooks/useToken';

const Register = () => {

    const { createUser, updateUser } = useContext(AuthContext)
    const { register, formState: { errors }, handleSubmit } = useForm();
    const [data, setData] = useState();
    const [createUserEmail, setCreateUserEmail] = useState('')
    const [token] = useToken(createUserEmail);
    const navigate = useNavigate();

    if(token){
        navigate('/')

    }

    const handleRegister = data => {
        createUser(data.email, data.password)
            .then(result => {
                const user = result.user;
                //navigate('/');
                console.log(data.name)

                const userInfo = {
                    displayName: data.name
                }
                updateUser(userInfo)
                    .then(() => {
                        saveUser(data.name, data.email);
                    })
                    .catch(err => {
                        console.log(err)
                    })
                console.log(user)

            })
            .catch(error => {
                console.log(error)
            })
    }

    const saveUser = (name, email) => {
        const user = { name, email };
        fetch('https://denticare-server-sumonhasan55.vercel.app/users', {
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify(user)
        })
            .then(res => res.json())
            .then(data => {
                console.log(data)
                setCreateUserEmail(email);
               


            })
    }

    const getUserToken = email => {
        fetch(`https://denticare-server-sumonhasan55.vercel.app/jwt?email=${email}`)
            .then(res => res.json())
            .then(data => {
                if (data.accessToken) {
                    localStorage.setItem('accessToken', data.accessToken
                    )
                }
            })
    }

    return (

        <div className="mx-auto text-center justify-center my-10 lg:w-1/3 shadow-lg p-10 rounded-lg">
            <div className="">
                <h1 className='font-bold text-3xl'>Register!</h1>

            </div>
            <form onSubmit={handleSubmit(handleRegister)}>


                <div className="form-control w-full ">
                    <label className="label">
                        <span className="label-text">Name</span>
                    </label>
                    <input {...register("name",
                        { required: true }
                    )

                    } type="text" placeholder="Your Name" className="input input-bordered w-full  " />
                    {errors.name && <p className='text-red-600'>{errors.name?.message}</p>}
                </div>

                <div className="form-control w-full ">
                    <label className="label">
                        <span className="label-text">Email</span>
                    </label>
                    <input {...register("email",
                        { required: true }
                    )

                    } type="email" placeholder="Your Email" className="input input-bordered w-full  " />
                    {errors.email && <p className='text-red-600'>{errors.email?.message}</p>}
                </div>

                <div className="form-control w-full ">
                    <label className="label">
                        <span className="label-text">Password</span>
                    </label>
                    <input {...register("password",
                        {
                            required: "Password is Required",
                            minLength: { value: 6, message: "Password Must be 6 character or longer" },
                        },


                    )}
                        aria-invalid={errors.password ? "true" : "false"}
                        type="password" placeholder="Password" className="input input-bordered w-full " />
                    {errors.password && <p className='text-red-600'>{errors.password?.message}</p>}
                </div>
                <button className="btn btn-info w-full my-5">SignUp</button>
                <div className="flex flex-col w-full border-opacity-50">

                    <div className="divider">OR</div>

                </div>
                <Link to='/login'><button className="btn btn-outline w-full my-5">Login</button></Link>

            </form>
        </div>
    );
};

export default Register;



